import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

export const AbilityContext = createContext();
/**
 * Create Can component to validate user permission
 *
 *
 */

export const Can = createContextualCan(AbilityContext.Consumer);

export { ABILITY_ACTION, ABILITY_SUBJECT };
